import { Query } from '../Model/Query';
import { Rol } from '../Model/Rol';
import { User } from '../Model/User';
export class UsersService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(userId) {
        if (userId) {
            const response = await this.apiService.get('user/' + userId);
            if (!response.ok) {
                throw new Error(`Error al obtener los usuarios.`);
            }
            const content = await response.json();
            if (content) {
                const user = new User(content);
                return user;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener UserId.`);
        }
    }
    async findUsers(opts) {
        var _a;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.search) {
                query.addFilter('search', [opts.filters.search]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`users?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los usuarios.`);
            }
            const content = await response.json();
            return content.map(user => new User(user));
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async findTypes() {
        const response = await this.apiService.get('users_types');
        if (!response.ok) {
            throw new Error(`Error al obtener los roles.`);
        }
        const content = await response.json();
        return content.map(rol => new Rol(rol).getState());
    }
    async saveUser(user) {
        if (user) {
            const response = await this.apiService.post('user', user.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el usuarios.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async findActualUser() {
        const response = await this.apiService.get('user');
        if (!response.ok) {
            throw new Error(`Error al obtener el usuario.`);
        }
        const content = await response.json();
        if (content) {
            const user = new User(content);
            return user;
        }
        return;
    }
    async findOneByAgentId(agentId) {
        if (agentId) {
            const response = await this.apiService.get('user/agent/' + agentId);
            if (!response.ok) {
                throw new Error(`Error al obtener el usuario.`);
            }
            const content = await response.json();
            if (content) {
                const user = new User(content);
                return user;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener UserId.`);
        }
    }
    async findUserSigner() {
        const response = await this.apiService.get('user/signer');
        if (!response.ok) {
            throw new Error(`Error al obtener el usuario.`);
        }
        const content = await response.json();
        if (content) {
            const user = new User(content);
            return user;
        }
        return;
    }
    async findAgents() {
        const response = await this.apiService.get('agents');
        if (!response.ok) {
            throw new Error(`Error al obtener los usuarios.`);
        }
        const content = await response.json();
        return content.map(user => new User(user));
    }
}
